import { z } from "zod";

export enum BrandColorCategory {
  Options = 1,
  Matrix = 2,
  Ranking = 3,
}

export enum ColorPaletteType {
  Preset = 1,
  Brand = 2,
  Project = 3,
}

export enum MediaOrientation {
  Square = 1,
  Horizontal = 2,
}


export type ColorPalette = {
  id: number;
  colors: string[];
  categoryId: BrandColorCategory;
  name: string;
  typeId: ColorPaletteType;
  createdBy: number;
  createdOn: Date;
};

export type CategoryTheme = {
  paletteId: ColorPalette['id'];
} & Pick<ColorPalette, 'categoryId' | 'name'>;

export type ThemeColors = {
  bubble: string | null;
  primary: string | null;
  prompt: string | null;
};

export const paletteSchema = z.object({
  id: z.number(),
  colors: z.array(z.string()),
  categoryId: z.enum(BrandColorCategory),
  name: z.string(),
  typeId: z.enum(ColorPaletteType),
  createdBy: z.number().nullable(),
  createdOn: z.coerce.date(),
  editable: z.boolean(),
});

export const categoryThemeSchema = z.object({
  paletteId: z.number(),
  categoryId: z.enum(BrandColorCategory),
  name: z.string(),
});

export const BrandingSchema = z.object({
  logos: z.object({
    landscape: z.object({
      url: z.string(),
    }).optional(),
    square: z.object({
      url: z.string(),
    }).optional(),
  }),
  theming: z.object({
    palettes: z.array(paletteSchema),
    themes: z.array(categoryThemeSchema),
  }),
  enabled: z.boolean(),
  colors: z.object({
    bubble: z.string().nullable(),
    primary: z.string().nullable(),
    prompt: z.string().nullable(),
  }),
});
export type Branding = z.infer<typeof BrandingSchema>;